
import { LoginData } from '@/interface/auth/login.interface'
import { defineComponent } from 'vue'
import { mapMutations, mapState, mapActions } from 'vuex';
import LoaderCube from "@/components/timer/Loader.vue";

export default defineComponent({
    name: 'LoginModal',
    components: {
      LoaderCube
    },
    data() {
        return {
            credentials: {
              username: '',
              password: ''
          } as LoginData,

          loading: false
        }
    },
    methods: {
    toggleModal: function(){
      this.ToggleAuthLoginModal();
    },
    login(){
      var user = {username: this.credentials.username, password: this.credentials.password}
      this.loading = true;
      this.loginUser(user).then((res: Response) => {
        console.log(res)
        if (this.loginMessage.message){
          this.loading = false;
        }
        else {
          this.loading = false;
          this.toggleModal()
          window.location.reload()
        }
      }).catch((err: Error) => console.log(err))
    },
      ...mapMutations('authModule', ['ToggleAuthLoginModal']),
      ...mapActions("authModule", ['loginUser'])
    },
    computed: {
      ...mapState('authModule', ['authLoginModal', 'loginMessage'])
    }
})
